import { styled } from '@mui/styles';

export const VideoDanaPlayer = styled('div')({
  display: 'block',
  position: 'relative',
  width: '100%',
  height: '100%',
  background: '#000',
});
